import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export interface SaveTask {
  RmiBirth?: string;
  RmiCompanyId: string;
	RmiCompletedDate: string;
	RmiCreatedBy: string;
	RmiCreatedDate: string;
  RmiDueDate: string;
  RmiMembId?: string;
	RmiMembMpiNo: string;
	RmiModifiedBy: string;
	RmiModifiedDate: string;
  RmiNextReviewDate: string;
  RmiRevFullName?: string;
  RmiTaskAcuity?: any;
	RmiTaskAcuityId: number;
	RmiTaskDescription: string;
  RmiTaskOwner: string;
  RmiTaskStatus?: any;
	RmiTaskStatusId: number;
	RmiUid: number;
  editInline?: boolean;
}

export const saveTask = (task: SaveTask) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.eligibilityMCP.isSaving) { return Promise.reject(); }

  dispatch({ type: types.SAVE_MCP_TASK_REQUEST });

  return api.eligibility.mcp.saveTask(task)
    .then((res: any) => {

      dispatch({
        type: types.SAVE_MCP_TASK_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.SAVE_MCP_TASK_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const deleteTask = (id: number, userId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.eligibilityMCP.isDeleting) { return Promise.reject(); }

  dispatch({ type: types.DELETE_MCP_TASK_REQUEST });

  return api.eligibility.mcp.deleteTask(id, userId)
    .then((res: any) => {

      dispatch({
        type: types.DELETE_MCP_TASK_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.DELETE_MCP_TASK_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
